<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12" v-if="!modelDefault.devId">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备" prop="devId">
              <j-search-select-tag
                dict="`iwt-wf`.dev_list,dev_name,id,del_flag=0 order by sort asc"
                v-model="model.devId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供水流域" prop="devProcessId">
              <j-dict-select-tag
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择供水流域"
                type="list"
                v-model="model.devProcessId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="网关编码" prop="hubCode">
              <a-input disabled placeholder="请输入网关编码" v-model="model.hubCode"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="测点名称" prop="pointName">
              <a-input @change="setDefaultDataUnit()" placeholder="请输入测点名称" ref="pointName" v-model="model.pointName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="简称" prop="shortName">
              <a-input placeholder="请输入测点简称" ref="shortName" v-model="model.shortName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="点号" prop="pointCode">
              <a-input
                :disabled="this.model.dataSource !== 'calc' || Boolean(Number(model.id))"
                placeholder="请输入点号"
                v-model="model.pointCode"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="位号" prop="pointTag">
              <a-input placeholder="请输入位号" v-model="model.pointTag"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数据类型" prop="dataType">
              <j-dict-select-tag dictCode="point_data_type" placeholder="请选择数据类型" type="list" v-model="model.dataType" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计量单位" prop="dataUnit">
              <a-input placeholder="请选择计量单位" v-model="model.dataUnit"></a-input>

              <!-- <a-tree-select
                :treeData="pointTypeTree"
                @change="selectPointType"
                allowClear
                placeholder="请选择计量单位"
                showSearch
                treeDefaultExpandAll
                treeNodeFilterProp="title"
                v-model="model.dataUnit"
              ></a-tree-select>-->
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数据来源" prop="dataSource">
              <j-dict-select-tag
                dictCode="point_data_source"
                disabled
                placeholder="请选择数据来源"
                type="list"
                v-model="model.dataSource"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="业务属性" prop="dataCategory">
              <a-input placeholder="请输入业务属性" v-model="model.dataCategory"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否只读" prop="readonly">
              <j-dict-select-tag dictCode="yn" type="radioButton" v-model="model.readonly" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="量程上限" prop="toprange">
              <a-input-number placeholder="请输入量程上限" style="width: 100%" v-model="model.toprange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="量程下限" prop="botrange">
              <a-input-number placeholder="请输入量程下限" style="width: 100%" v-model="model.botrange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="倍率" prop="multi">
              <a-input-number placeholder="请输入倍率" style="width: 100%" v-model="model.multi" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="偏移" prop="shift">
              <a-input-number placeholder="请输入偏移" style="width: 100%" v-model="model.shift" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="变化趋势" prop="trend">
              <j-dict-select-tag dictCode="point_data_trend" placeholder="变化趋势" type="list" v-model="model.trend" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24" v-if="model.dataSource === 'calc'">
            <a-form-model-item
              :labelCol="{ xs: { span: 24 }, sm: { span: 3 } }"
              :wrapperCol="{ xs: { span: 24 }, sm: { span: 20 } }"
              label="计算公式"
              prop="expression"
            >
              <a-textarea :rows="5" style="width:90%; font-size:12px" v-model="model.expression" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'IotModelPointsForm',
    components: {},
    props: {
      // 表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      idType: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        model: {
          dataType: 'float32',
          dataSource: 'calc',
          dataCategory: '',
          readonly: '1',
          multi: 1,
          shift: 0,
          trend: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          pointName: [{ required: true, message: '请输入测点名称!' }],
          pointCode: [{ required: true, message: '请输入点号!' }],
          dataType: [{ required: true, message: '请输入数据类型!' }],
          dataSource: [{ required: true, message: '请输入数据来源!' }]
        },
        pointTypeData: [],
        pointTypeTree: [],
        url: {
          getPointTypeData: '/monitor/iotModelPoints/pointType',
          add: '/monitor/iotModelPoints/add',
          edit: '/monitor/iotModelPoints/edit',
          queryById: '/monitor/iotModelPoints/queryById'
        },
        isCopy: false
      }
    },

    computed: {
      formDisabled () {
        return this.disabled
      }
    },
    created () {
      // 备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
      this.getPointTypeData()
    },
    methods: {
      add (devId, idType) {
        if (idType) {
          this.modelDefault[idType] = devId
        }
        this.edit(this.modelDefault)
      },
      edit (record) {
        this.model = Object.assign({}, record)
        this.visible = true
      },
      copy (record) {
        this.model = this.$Jlodash.omit(record, ['id', 'pointName'])
        this.isCopy = true
        this.visible = true
        this.$nextTick(() => {
          this.$refs.pointName.focus()
        })
        // this.model = this.$Jlodash.omit(record, ['id'])
      },
      submitForm () {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            if (!this.model.shortName) {
              this.model.shortName = this.model.pointName
            }
            httpAction(httpurl, this.model, method)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        })
      },
      getPointTypeData () {
        getAction(this.url.getPointTypeData).then(res => {
          if (res.success) {
            this.pointTypeData = res.result.map(item => {
              item.keyword = item.keyword.replace(/，/g, ',').replace(/\s/g, '')
              item.keyword = item.keyword.split(',')
              return item
            })
          } else {
            this.$message.warning(res.message)
          }
        })
      },
      setDefaultDataUnit () {
        if (this.isCopy) return
        if (this.model.pointName && this.pointTypeData.length > 0) {
          // this.pointTypeData 中找到所有keyword元素在this.model.pointName中存在的元素
          let pointTypeData = this.pointTypeData.filter(item => {
            return item.keyword.some(keyword => {
              return this.model.pointName.indexOf(keyword) > -1
            })
          })
          // 如果pointTypeData中有元素，则设置默认单位
          if (pointTypeData.length > 0) {
            this.model.dataUnit = pointTypeData[0].unit
            this.model.toprange = pointTypeData[0].top_range
            this.model.botrange = pointTypeData[0].bottom_range
          }
        }
      }
    }
  }
</script>
